import { Component, OnInit } from "@angular/core";
import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";

@Component({
    selector: "app-datepicker-data-config",
    templateUrl: "./datepicker-data-config.component.html",
    standalone: false
})
export class DatePickerDataConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "DatePickerDataConfigComponent";


    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
        if (!this.componentData) {
            this.componentData = { config: { maxDaysPast: undefined, maxDaysFuture: undefined } };
        } else if (!this.componentData.config) {
            this.componentData.config = { maxDaysPast: undefined, maxDaysFuture: undefined };
        }
    }

}
